import {
  AutocompleteRenderGetTagProps,
  AutocompleteRenderOptionState,
} from '@mui/material'
import { CellPropsBase, CellTitle, CellValueArea, FormCell } from '.'
import { ReferencedEntity } from '../../../../../domain/value-object/ReferencedEntity'
import { MultiAutocomplete } from '../../../../components/inputs/MultiAutocomplete'
import { ReactNode, useMemo } from 'react'
import { renderOptionWithIcon } from '../../../../components/inputs/Autocomplete/variants'

type MultiAutocompleteCellProps<Entity extends ReferencedEntity> = {
  value: Entity[]
  onChange?: (v: Entity[]) => void
  search: (input: string) => Promise<Entity[]>
  displayIcon?: boolean
  renderTags?: (
    value: Entity[],
    getTagProps: AutocompleteRenderGetTagProps
  ) => ReactNode
  renderOption?: (option: Entity) => JSX.Element
  renderOptionRaw?: (
    // TODO Remove
    props: React.HTMLAttributes<HTMLLIElement>,
    option: Entity,
    state: AutocompleteRenderOptionState
  ) => JSX.Element
  groupBy?: (option: Entity) => string
  sortOptions?: (options: Entity[]) => Entity[]
  defaultExpandedGroups?: string[]
} & CellPropsBase

export const MultiAutocompleteCell = <Entity extends ReferencedEntity>({
  cellWidth,
  label,
  help,
  value,
  onChange,
  search,
  editable = true,
  required = false,
  edited,
  validationErrors,
  displayIcon = false,
  renderTags,
  renderOption: _renderOption,
  renderOptionRaw,
  groupBy,
  sortOptions,
  defaultExpandedGroups,
}: MultiAutocompleteCellProps<Entity>) => {
  const renderOption = useMemo(() => {
    return _renderOption ?? (displayIcon ? renderOptionWithIcon : undefined)
  }, [_renderOption, displayIcon])
  return (
    <FormCell cellWidth={cellWidth}>
      <CellTitle title={label} required={required} help={help} />
      <CellValueArea edited={edited} validationErros={validationErrors}>
        <MultiAutocomplete
          value={value}
          onChange={onChange}
          search={search}
          renderTags={renderTags}
          renderOption={renderOption}
          renderOptionRaw={renderOptionRaw}
          groupBy={groupBy}
          sortOptions={sortOptions}
          defaultExpandedGroups={defaultExpandedGroups}
        />
      </CellValueArea>
    </FormCell>
  )
}
